var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-padding" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "spaceBetween",
          staticStyle: { "margin-bottom": "0.24rem" },
        },
        [
          _c(
            "div",
            { staticClass: "spaceLeft" },
            [
              _c("div", { staticClass: "detail-title-1" }, [
                _vm._v("Validators"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    "margin-left": "0.16rem",
                    color: "#3172fd !important",
                    "font-family": "HurmeGeometricSans2-SemiBold",
                  },
                  attrs: { type: "text" },
                  on: { click: _vm.toProfile },
                },
                [
                  _vm._v("\n        STAKED RECORD"),
                  _c("i", { staticClass: "el-icon-d-arrow-right" }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-card is-border" }, [
        _c(
          "div",
          { staticClass: "common-card-main" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "common-table",
                attrs: {
                  data: _vm.tableList,
                  "row-class-name": _vm.tableRowClassName,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: " ", width: "30px" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "operator_address", label: "Validators" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "userinfo" }, [
                            _c("div", { staticClass: "img" }, [
                              row.description.pictures
                                ? _c("img", {
                                    attrs: {
                                      src: row.description.pictures,
                                      alt: "",
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: require("@/assets/image/stake/icon.png"),
                                      alt: "",
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(row.description.moniker)),
                            ]),
                            _vm._v(" "),
                            row.status === "BOND_STATUS_BONDED"
                              ? _c("span", { staticClass: "tag-active" }, [
                                  _vm._v(
                                    "\n                Active\n              "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            row.description.website
                              ? _c("span", {
                                  staticClass: "web",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOpen(
                                        row.description.website
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: { label: "Stake", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "div",
                              [
                                _c("big-number", {
                                  attrs: { number: row.tokens },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "td-word-sm" }, [
                                  _vm._v("UNIT"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("Ratio", {
                                  staticStyle: { "font-size": "14px" },
                                  attrs: {
                                    count: 2,
                                    number: row.delegator_shares,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "td-word-sm",
                                    staticStyle: { "font-size": "14px" },
                                  },
                                  [_vm._v("%")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _vm._v("\n            Stake\n            "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _vm._v(
                                  "\n                The first number displayed is the amount of UNIT staked with\n                this validator."
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                The percentage indicates how much these shares account for the\n                total "
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                amount of stake UNIT in the network.\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", { staticClass: "el-icon-question" }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  {
                    attrs: { label: "Expected APR", align: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "td-word-sm" }, [
                              _vm._v(_vm._s(row.apy)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "template",
                      { slot: "header" },
                      [
                        _vm._v("\n            Expected APR\n            "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _vm._v(
                                  "\n                This is an estimate of the annualized return"
                                ),
                                _c("br"),
                                _vm._v(
                                  " from staking, based on historical performance."
                                ),
                                _c("br"),
                                _vm._v(
                                  " Future performance may vary.\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("i", { staticClass: "el-icon-question" }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "operation", label: " ", align: "right" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleStake(row)
                                },
                              },
                            },
                            [_vm._v("Stake")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              attrs: {
                total: _vm.queryParams.total,
                page: _vm.queryParams.page,
                limit: _vm.queryParams.pageSize,
              },
              on: {
                "update:total": function ($event) {
                  return _vm.$set(_vm.queryParams, "total", $event)
                },
                "update:page": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.queryParams, "pageSize", $event)
                },
                pagination: function ($event) {
                  return _vm.getList()
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("StakeDia", { ref: "StakeDia", on: { success: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "text-align": "left",
          background: "linear-gradient( 45deg, #020202 0%, #001A49 100%)",
          color: "white",
          "border-radius": "0.16rem",
          padding: "20px",
          "margin-bottom": "20px",
          "font-size": "20px",
          "font-family": "HurmeGeometricSans2-SemiBold",
          border: "1px solid #606266",
        },
      },
      [
        _c("img", {
          staticStyle: { width: "20px", height: "20px" },
          attrs: { src: require("@/assets/image/announcement.png") },
        }),
        _c("br"),
        _vm._v(
          "\n    The Treasurenet network has completed its latest upgrade, and the REP Bid mechanism is now live on mainnet."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n    REP holders can now bid REP to unlock Bonus UNIT rewards, activating the full validator reward logic across the network."
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n    Users may earn REP by doing real-world productive activity that the network can verify. We will continue to introduce additional REP sources as the ecosystem expands."
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://docs.treasurenet.io/docs/5/REP%20Score" } },
          [_vm._v("Learn more about REP")]
        ),
        _c("br"),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://docs.treasurenet.io/docs/6/What%20is%20Bonus%20Stake",
            },
          },
          [_vm._v("Learn more about REP Bonus Staking")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }